import { datadogLogs } from '@datadog/browser-logs';
import type { Logger, LogsInitConfiguration } from '@datadog/browser-logs';
import { BaseLogger } from './base-logger';
import type { Scope, User } from './types';

class DatadogLogger extends BaseLogger {
  private logger: Logger;

  constructor(logger: Logger, logFunction: BaseLogger['logFunction']) {
    super(logFunction);
    this.logger = logger;
  }

  public setContextProperty(key: string, value: any) {
    this.logger.setContextProperty(key, value);
  }
}

export const initLogger = (config: LogsInitConfiguration) => {
  datadogLogs.init(config);
};

export const setGlobalContext = (data: Record<string, any>) => {
  datadogLogs.setGlobalContext(data);
};

export const setGlobalContextProperty = (key: string, value: any) =>
  datadogLogs.setGlobalContextProperty(key, value);

export const clearGlobalContext = () => datadogLogs.clearGlobalContext();

export const setUser = (user: User) => {
  datadogLogs.setUser(user);
};

export const clearUser = () => datadogLogs.clearUser();

export const scopedLogger = (name: Scope, fileName?: string): DatadogLogger => {
  let scopedLogger = datadogLogs.getLogger(name);
  const context = fileName
    ? { name, scopeName: name, fileName }
    : { name, scopeName: name };

  if (!scopedLogger) {
    scopedLogger = datadogLogs.createLogger(name, {
      level: 'info',
      handler: 'http',
      context: context,
    });
  }

  return new DatadogLogger(scopedLogger, (type, message, context, error) => {
    scopedLogger[type](message, { messageContext: context }, error);
  });
};

export type ScopedLogger = ReturnType<typeof scopedLogger>;
